import { AxiosRequestConfig } from "axios";

import type { File } from "@supplier/entity";

import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";

// 文件服务
export class FileService extends BaseService<File, File, Record<string, unknown>, Record<string, unknown>> {
    public async uploadFile(params: FormData, isNotShowLoading: boolean = false): Promise<File> {
        const { data } = await this.service.post(`${this.path}/upload`, params, {
            isNotShowLoading
        } as unknown as AxiosRequestConfig);
        return data;
    }

    public async getFileById(id: number): Promise<File> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    public async getFileByIds(ids: number[]): Promise<File[]> {
        // POST 查询允许业务轮询或并发读取，不参与写请求防重。
        const { data } = await this.service.post(`${this.path}/ids`, ids, { dedupe: false });
        return data;
    }

    public async findById(id: number): Promise<File> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }
}
export const fileService = new FileService("/file", httpRequest);
